import server from "../Server";
import { RefreshAuthPayload, RefreshAuthResponse } from "../../../gateways";

export const RefreshAuth = async (params: RefreshAuthPayload): Promise<RefreshAuthResponse | null> => {
  // console.log("before refresh ", params.refresh_token);
  const { data } = await server.auth.refreshSession({ refresh_token: params.refresh_token });
  if (!data || !data.user || !data.session) return null;
  const supaUser = data.user;
  const supaSession = data.session;
  // console.log("after refresh ", supaSession.refresh_token);
  return {
    user: {
      uid: supaUser.id,
      email: supaUser.email || "",
      confirmed_at: supaUser.confirmed_at,
      created_at: supaUser.created_at,
    },
    auth: {
      access_token: supaSession.access_token,
      refresh_token: supaSession.refresh_token,
      expires_in: supaSession.expires_in,
      expires_at: supaSession.expires_at,
    },
  };
};
